import React from "react";
import { format } from "../../lib/globalize-util";
import { ConfirmDialog } from "./index";
import { Form } from "formsy-react";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import { DATATEST } from "constants/integration";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import { searchModalLabels, SearchTypes, searchModalLinks } from "constants/searchModal";

export const SearchModal = ({ open, onClose, onConfirm, handleRadioChange, selectedSearchType, brandId }) => {
    const styles = {
        infoIcon: {
            marginLeft: "-10px",
            color: "grey",
            width: "18px",
            height: "18px",
        },
        underline: {
            textDecoration: "underline",
            color: "#45d0c8",
        },
        contentStyle: {
            maxWidth: "540px",
        },
        radio: {
            color: "#2fc7be",
        },
        title: {
            color: "#303030",
            padding: "10px 0px",
            margin: "0px",
            fontSize: "18px",
            fontFamily: "Lato, sans-serif",
        },
        radioButtonLabel: {
            color: "#303030",
            padding: "5px 0px 0px",
            margin: "0px",
            fontSize: "12px",
            fontFamily: "Lato, sans-serif",
        },
        container: {
            height: "1px",
            margin: "0px -20px",
        },
        description: {
            color: "#303030",
            padding: "10px 0px",
            margin: "0px",
            fontSize: "12px",
            fontFamily: "Lato, sans-serif",
        },
        standardtype: {
            color: "#303030",
            marginBottom: "-15px",
            marginTop: "-10px",
        },
        expandedtype: {
            color: "#303030",
        },
        line: {
            height: "1px",
            background: "white",
            margin: "10px -20px",
            marginBottom: "auto",
        },
        infoText: {
            color: "#303030",
            fontSize: "12px",
            borderTop: "1px solid #cacacc",
            paddingTop: "10px",
        },
        toolTipText: {
            fontSize: "10px",
        },
        searchTypeLabel: {
            fontFamily: "Lato, sans-serif",
        },
        radioLabelStyle: {
            display: "flex",
            alignItems: "center",
        },
    };
    const title = <Typography style={styles.title}>{format("Search settings")}</Typography>;
    const description = format("Closing your browser resets your search type to standard.");
    const radioButtonLabelText = <Typography style={styles.radioButtonLabel}>{format("Search type")}</Typography>;

    const searchInfo = (searchType) => {
        const searchTypeLabel = <Typography style={styles.searchTypeLabel}>{searchType}</Typography>;
        return (
            <div style={styles.radioLabelStyle}>
                {searchTypeLabel}
                <Tooltip
                    arrow={true}
                    PopperProps={{
                        popperOptions: {
                            modifiers: {
                                offset: {
                                    enabled: true,
                                    offset: "100px, 0px",
                                },
                            },
                        },
                    }}
                    title={
                        <Typography style={styles.toolTipText}>
                            {searchType === "Standard"
                                ? format(searchModalLabels.tooltipTextStandard)
                                : format(searchModalLabels.tooltipTextEnhanced)}
                        </Typography>
                    }
                    placement="right-start"
                >
                    <IconButton data-test={`${DATATEST.SEARCH_SETTINGS.MODAL.INFO_ICON}-${searchType}`}>
                        <React.Fragment>
                            <InfoOutlinedIcon style={styles.infoIcon} />
                        </React.Fragment>
                    </IconButton>
                </Tooltip>
            </div>
        );
    };

    return (
        <ConfirmDialog
            dataTestConfirm={DATATEST.SEARCH_SETTINGS.MODAL.CONFIRM}
            dataTestCancel={DATATEST.SEARCH_SETTINGS.MODAL.CANCEL}
            open={open}
            onConfirm={() => onConfirm(selectedSearchType)}
            onCancel={onClose}
            onRequestClose={onClose}
            contentStyle={styles.contentStyle}
            title={title}
            cancelLabel={format(searchModalLabels.cancelLabel)}
            confirmLabel={format(searchModalLabels.confirmLabel)}
            disabledConfirm={false}
        >
            <div style={styles.container}> </div>
            <Typography style={styles.description}>{description}</Typography>
            <Form>
                <FormControl>
                    <FormLabel id={searchModalLabels.searchTypeModalId}>{radioButtonLabelText}</FormLabel>
                    <RadioGroup
                        name={searchModalLabels.radioButtonName}
                        value={selectedSearchType}
                        onChange={(event) => handleRadioChange((event.target as HTMLInputElement).value)}
                    >
                        <FormControlLabel
                            style={styles.standardtype}
                            value={SearchTypes.StandardValue}
                            control={
                                <Radio data-test={DATATEST.SEARCH_SETTINGS.MODAL.RADIO_STANDARD} style={styles.radio} />
                            }
                            label={searchInfo(format(SearchTypes.Standard))}
                        />
                        <FormControlLabel
                            style={styles.expandedtype}
                            value={SearchTypes.ExpandedValue}
                            control={
                                <Radio data-test={DATATEST.SEARCH_SETTINGS.MODAL.RADIO_EXPANDED} style={styles.radio} />
                            }
                            label={searchInfo(format(SearchTypes.Expanded))}
                        />
                    </RadioGroup>
                </FormControl>
            </Form>
            <div style={styles.infoText}>
                {format(searchModalLabels.informationText)}&nbsp;
                <a target="_blank" href={searchModalLinks.productSearchLink} style={styles.underline}>
                    {format("product search")}
                </a>
                {"."}
            </div>
            <div style={styles.line}> </div>
        </ConfirmDialog>
    );
};
